module.exports = __webpack_public_path__ + "img/img-4.f4bc4f62.png";